import { render, staticRenderFns } from "./readonly-quill.vue?vue&type=template&id=42c462c0&"
import script from "./readonly-quill.vue?vue&type=script&lang=js&"
export * from "./readonly-quill.vue?vue&type=script&lang=js&"
import style0 from "./readonly-quill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports